import { render } from "./FaqsList.vue?vue&type=template&id=e8287a9c"
import script from "./FaqsList.vue?vue&type=script&lang=js"
export * from "./FaqsList.vue?vue&type=script&lang=js"

import "./FaqsList.vue?vue&type=style&index=0&id=e8287a9c&lang=css"

import exportComponent from "../../../../thejourney/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__